const state = {
    langFlagImg: ''
}

const getters = {
    langFlagImg(state) {
        return state.langFlagImg
    }
}

const actions = {
    changeFlag({ commit }) {
        commit('changeFlagImg')
    }
}

const mutations = {
    changeFlagImg(state, flagImg) {
        state.langFlagImg = flagImg
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}